<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：ファイルアップロード確認(その他)画面(FMUploadConfirm)                                                               _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <!-- ポップアップ：アップロード確認 -->
  <!-- <div class="overlay hide" id="popup-upload" data-role="popup-close" data-popup-width="920"> -->
  <div  class="overlay" :class="[isFileUploadDlgShow ? showClass : hideClass]" id="popup-import" ref="content">
    <div class="popup" style="width: 920px">

      <div class="popup-head">アップロード確認</div>
      <div class="popup-body blue">
        <div class="frm-row">
          <div class="frm-item grow left">
            <!-- ****  メッセージ表示領域 **** -->
            <p class="errMsg title-ico ico-warning" v-show="errors != ''">
              <ErrorMessage :errors="errors"></ErrorMessage>
            </p>
          </div>
        </div>
        <p>ファイルをアップロードします。よろしいですか？</p>
        <ul class="note">
          <li>アップロードするファイルを選択してください。</li>
          <li>同名のファイルについて上書きせず別名で保存する場合は、自動でファイル名の末尾に付番して保存します。</li>
        </ul>
        <!-- <div class="frm-row" v-if="userType == '0' && agreement == '0'"> -->
        <div class="frm-row">
          <span class="frm-label w-100px"><strong>上書き設定</strong></span>
          <div @keydown.left.stop.prevent="toggleRadio" @keydown.right.stop.prevent="toggleRadio"
            class="frm-toggle frm-size-toggle-2" tabindex="0" ref="refCollectively">
            <label>
              <input type="radio" id="collect1" :value="true" v-model="collectively" />
              <span>上書きする</span>
            </label>

            <label>
              <input type="radio" id="collect2" :value="false" v-model="collectively" />
              <span>上書きせず別名で保存する</span>
          </label>
        </div>
        </div>

        <!-- {{ this.fileType }}
            {{ this.fileTypeList }}
            {{ this.selectedIndexList }} -->

        <div class="table-wrap mt-20px">
          <div class="table-scroll-header">
            <table class="table-select single-select">
              <colgroup>
                <col style="width: 40px;">
                <col style="width: auto;">
              </colgroup>
              <thead>
                <tr>
                  <th class="multi-select-item">
                    <!-- 全選択処理 -->
                    <label class="frm-checkbox">
                      <input type="checkbox" @click="selectAllRow" :checked="checkAll" />
                      <span tabindex="0" class="checkbox-item" @keydown.space.stop.prevent="selectAllRow">
                      </span>
                    </label>
                  </th>
                  <th class="sort alignleft">対象ファイル
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-scroll-body h-270px">
            <table class="table-select multi-select-item">
              <colgroup>
                <col style="width: 40px; background-color: #fff;">
                <col style="width: auto; background-color: #fff;">
              </colgroup>
              <tbody>
                <tr v-for="(file, index) in this.uploadFiles" :key="index" @click="selectRow(index)" :class="{
                  selected: this.selectedIndexList.includes(index)
                }">
                  <td class="aligncenter">
                    <label class="frm-checkbox">
                      <input type="checkbox" v-bind:id="'chk' + index" v-bind:value="index" @change="selectRow(index)"
                        :checked=this.selectedIndexList.includes(index) />

                      <span class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="selectRow(index)">
                      </span>
                    </label>
                  </td>
                  <td class="alignleft">
                    <span>{{ file.name }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button class="frm-btn strong large" @click="handleYes" :disabled="selectedIndexList.length == 0"
              tabindex="0">
              はい
            </button>
            <button class="frm-btn large" @click="handleNo" @blur="onblur" tabindex="0">
              いいえ
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Common from "@/util/common.js";
import validation from "@/util/validation.js";
import { API_STFMFM02C17_FileUpload } from "@/api/Modules/FM02/STFMFM02C17.js";
import { thisTypeAnnotation } from "@babel/types";
export default {
  name: "SFMFileUpload",
  components: {
    ErrorMessage,
  },
  props: {
    isFileUploadDlgShow: {
      type: Boolean,
      required: true,
    },
    uploadFiles: {
      type: [],
      required: true,
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      files: [],
      errors: [],
      targetInfo: "",
      infoNameArea: "",
      infoNameAddArea: "",
      collectively: true,
      list: [],
      selectedIndexList: [], // 選択Indexリスト

      fileType: "",
      fileTypeList: [],
      rdbCollect: [],
      //全行選択時
      checkAll: true,
      totalCount: 0,
      // isFileUploadDlgShow:true,
    };
  },
  created() {
    // this.processDialogue(false);
  },
  computed: {
    // **********************************************
    // * ボタン活性、非活性
    // **********************************************
    isDisabled() {
      return this.files.length == 0 ? true : false;
    },
  },
  watch: {
    isFileUploadDlgShow: function(newVal) {
      this.handleBodyScrollOnModalStateChange(newVal)
    },

    uploadFiles: function (newVal) {
      if (newVal.length > 0) {
        this.$nextTick(function () {
          this.initFocus();
        });

        this.selectedIndexList = new Array();
        this.fileTypeList = new Array();
        for (let i = 0; i < newVal.length; i++) {
          this.selectedIndexList.push(i);
          this.fileTypeList.push(0);
        }
        this.totalCount = this.selectedIndexList.length;
      }
    },
  },
  methods: {
    // ...mapMutations("businessModule", ["uploadCmfDialogue", "processDialogue"]),
    // ...mapActions("businessModule", ["showProcessDialogue"]),
    ...mapMutations("businessModule", [
      "processDialogue",
      "handleBodyScrollOnModalStateChange"
    ]),
    onblur(e) {
      if (!e) return;
      e.preventDefault();
      const focusable = this.$refs.content.querySelectorAll(
        '[tabindex]:not([tabindex="-1"])'
      );
      // Find and focus the first available element inside the dialog
      const el = [...focusable].find((el) => !el.hasAttribute("disabled"));
      el && el.focus();
    },
    // **********************************************
    // * いいえボタンをクリック
    // **********************************************
    handleNo() {
      // 初期化
      this.clearError();
      this.$emit("disagree");
    },

    // **********************************************
    // * はいボタンをクリック
    // **********************************************
    handleYes(e) {
      // 初期化
      if (e && e.srcElement) {
        e.srcElement.blur()
      }
      this.errors = [];
      // インポートボタン 非活性化
      this.isDisabled = true;

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      let uploadMax = 0;
      var countSize = 0;
      let formData = new FormData();
      for (let i = 0; i < this.uploadFiles.length; i++) {
        if (!this.selectedIndexList.includes(i)) {
          continue;
        }
        //入力値チェック
        if (this.checkInputData(this.uploadFiles[i], this.uploadFiles[i].name)) {
          return;
        }
        formData.append("FileInfos", this.uploadFiles[i], this.uploadFiles[i].name);
        countSize += this.uploadFiles[i].size;
        uploadMax++;
      }
      formData.append("OverWrite", this.collectively);
      //または合計サイズが115MBを超える。
      if (countSize / 1024 / 1024 / 115 > 1) {
        this.setErrMsg("MTFM1510", []);
        return true;
      }
      //処理中画面起動
      this.processDialogue(true);

      // API呼出
      API_STFMFM02C17_FileUpload(formData, config)
        .then((response) => {
          if (_.eq(response.result, "0000")) {
            this.clearError();
            this.processDialogue(false);
            this.$emit("disagree");
          } else {
            this.processDialogue(false);

            // エラー表示
            if (response.errorName != null && response.errorName.length > 0) {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [response.errorName[0]])
                )
              );
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
          //this.clearError();
        }).catch((err) => {
          if (err && err.status == 400) {
            this.errors.push(
              Common.createError(
                "MTFM1510",
                Common.getMessage("MTFM1510", [])
              )
            );
            this.processDialogue(false);
          }
        });
    },
    //入力値チェック
    checkInputData(realFiles, fileName) {
      var bRet = true;
      //拡張子が.html、.htmのファイルが含まれる　又はファイルの拡張子が存在しない。
      let file_type = fileName.split('.').pop();
      if (file_type == "html" || file_type == "htm" || file_type == "" || file_type == fileName) {
        this.setErrMsg("MTCL1107", [""]);
        return true;
      }

      // ファイル名に入力禁止文字が使用されている。
      // ※設計書『D - ED005_共通処理設計書.xlsx』参照。  
      if (
        !validation.checkNationalkinsokuchar(fileName) ||
        !validation.CheckFileNameInvalid(fileName)
      ) {
        this.setErrMsg("MTCL1098", ["名称"]);
        return true;
      }

      // 0バイトファイルはエラー
      if (realFiles.size == 0) {
        this.setErrMsg("MTFM1260", []);
        return true;
      }

      // 115Mを超えるファイルはエラー
      if (this.checkFileSize(realFiles.size)) {
        this.setErrMsg("MTFM1510", []);
        return true;
      }

    },
    /* ファイルサイズ(115M)チェック
     * @param {ファイルサイズ} fileSize 
     */
    checkFileSize(fileSize) {
      return fileSize / 1024 / 1024 / 115 > 1 ? true : false
    },

    /**
     * エラー内容セット
     * @param {エラーコード} errCd 
     * @param {エラーコードの埋め込み文字} param 
     */
    setErrMsg(errCd, param) {
      if (this.errors.length == 0) {
        this.errors.push(
          Common.createError(
            errCd,
            Common.getMessage(errCd, param)
          )
        );
      }
    },

    //行選択時の処理
    selectRow(index) {
      if (this.selectedIndexList.includes(index)) {
        let i = this.selectedIndexList.indexOf(index);

        this.selectedIndexList.splice(i, 1);
      } else {
        this.selectedIndexList.push(index);
      }
      var selectCount = this.selectedIndexList.length;
      if (this.totalCount == selectCount) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },

    // 全行選択時の処理
    selectAllRow: function () {
      this.checkAll = !this.checkAll;
      this.selectedIndexList = [];
      var _self = this;
      if (this.checkAll) {
        this.selectedIndexList = [];
        for (var i = 0; i < this.uploadFiles.length; i++) {
          this.selectedIndexList.push(i);
        }
      }
    },

    // **********************************************
    // * エラーメッセージ、ファイルの初期化処理
    // **********************************************
    clearError() {
      this.collectively = true;
      this.checkAll = true;
      this.files = [];
      this.errors = [];
    },

    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.refCollectively.focus();
    },
    toggleRadio() {
      this.collectively = !this.collectively
    }
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .frm-btn-row.footer-btn >.frm-item{
    margin-left: 0;
    flex-wrap: wrap;
    gap: 10px;
  }
  .frm-btn-row.footer-btn >.frm-item > .frm-btn:last-child{
    margin-left: 0;
  }
}
</style>